import posthog from "posthog-js";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN!, {
  api_host: "/ingest",
  ui_host: "https://eu.posthog.com",
  defaults: "2026-01-30",
  // Cookieless: keep the distinct id in memory only, nothing written to the device (no consent banner needed)
  persistence: "memory",
  capture_exceptions: true,
  debug: process.env.NODE_ENV === "development",
});
